module.exports = __webpack_public_path__ + "assets/img/0db403af4eb134431caea7e61efdc4fd.png";